export default __webpack_public_path__ + "static/media/forward_thin_fff_arab.bf2c5b4e.svg";